import TextButton from "@common/ui/TextButton";
import { useProjectDataStore } from "@state/projectDataStore";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { useStore } from "@state/store";
import gsap from "gsap";

function Sidebar_Splash() {
  const { splashData, brandingData } = useProjectDataStore((s) => ({
    splashData: s.splashData,
    brandingData: s.brandingData,
  }));
  const logo = brandingData?.logos[splashData?.logo];
  //
  const backgroundType = splashData?.splashBg;
  const backgroundMedia = backgroundType === "image/video"
    ? splashData?.splashBgMedia?.publicURL
    : `var(--${backgroundType})`;
  const isBackgroundMedia = backgroundMedia?.includes(".");
  const backgroundOpacity = splashData?.splashBgMediaOpacity;
  //
  const buttonBgColour = splashData?.buttonBgColour;

  const navigate = useNavigate();

  function animateSplash() {
    const t = gsap.timeline();

    t.to(".splashAnim", {
      autoAlpha: 1,
      ease: "power3.inOut",
      duration: 0.6,
    })
      .call(() => {
        navigate("info1");
      })
      .to(".splashAnim", {
        autoAlpha: 0,
        ease: "power3.inOut",
        duration: 0.6,
        delay: 0.6,
      });
  }

  return (
    <SplashWr
      style={{
        backgroundColor: isBackgroundMedia ? "black" : backgroundMedia,
      }}
    >
      {isBackgroundMedia &&
        (backgroundMedia?.includes(".mp4")
          ? (
            <SplashBgVideo
              style={{
                opacity: backgroundOpacity || 0.5,
                zIndex: -1,
              }}
              autoPlay
              muted
              loop
              playsInline
              src="/trinity.mp4"
            />
          )
          : (
            <SplashBgImg
              style={{
                opacity: backgroundOpacity || 0.5,
              }}
              src={backgroundMedia}
            />
          ))}
      <SplashLogo
        style={{
          width: "20rem",
        }}
        src={logo?.publicURL}
      />
      <Button>
        <TextButton
          onClick={() => animateSplash()}
          className="enterButton"
          color={buttonBgColour}
          variant="fill"
          icon={"/assets/icons/right-arrow.svg"}
          iconPosition="right"
        >
          Explore
        </TextButton>
      </Button>
    </SplashWr>
  );
}

const SplashWr = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
  z-index: 200 !important;
`;

const SplashBgImg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  object-fit: cover;
`;
const SplashBgVideo = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  object-fit: cover;
`;

const SplashLogo = styled.img`
  width: 25%;
`;

const Button = styled.div`
  .enterButton {
    letter-spacing: 6px;
    text-align: center;
    padding: 2rem;
    border-radius: 2rem;
    font-style: italic;
    display: flex;
    gap: 0.5rem;
  }

  img {
    transform: rotate(90deg);
  }
`;

export default Sidebar_Splash;
